import React from 'react'
import '../style/slider.scss'

class Slider extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            posts : []
        };
    }

	componentWillMount () {
        this.setState({
        posts:[
            {
                content: '"The community at Crossfit Deliverance is AMAZING! The people here are super supportive and really help you push through hard workouts."',
                author: '-Steve R.'
            },
            {
                content: '"The coaches here are great. They have really helped me improve my form, and overall strength"',
                author: '-Sara H.'
            },
            {
                content: '"Crossfit Deliverance really helped me make friends when I first moved here. "',
                author: '-Erin T.'
            },

        ],
        i: 0
        });

        this.interval = setInterval(() => {
            if(this.state.i == this.state.posts.length-1){
                let x = 0;
                this.setState({i:x});
            }else{
                let x = this.state.i + 1;
                this.setState({i:x});
            }
            
        },4500);
    }

  
    render () {
    return (
        <section className="testimonials">
            <div id="testimonial_box" key={this.state.i} className="testimonial_box slide-up">
                <p className="testimonial_title">{this.state.posts[this.state.i].content}</p>
                <p className="tesimonial_author">{this.state.posts[this.state.i].author}</p>
            </div>
        </section>
    );
   }
};
export default Slider;